export default {
  tableColumn: {
    minHeight: '500px',
    maxHeight: '700px',
    overflowY: 'auto',
    overflowX: 'auto',
    display: 'inline-grid',
    scrollbarColor: '#C4C4C4 transparent',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '10px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      backgroundClip: 'padding-box',
      borderRadius: '10px',
      border: `3px solid transparent`
    },
    '&::-webkit-scrollbar-thumb:horizontal': {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      backgroundClip: 'padding-box',
      borderRadius: '10px',
      border: `6px solid transparent`
    },
    '&::-webkit-scrollbar-button': {
      width: '0',
      height: '0',
      display: 'none'
    },
    '&::-webkit-scrollbar-corner': {
      display: 'none'
    }
  },
  chartStyle: {
    width: '100%',
    minHeight: '220px',
    maxHeight: '340px',
    overflowY: 'auto',
    overflowX: 'auto',
    display: 'inline-grid',
    scrollbarColor: '#C4C4C4 transparent',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '10px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      backgroundClip: 'padding-box',
      borderRadius: '10px',
      border: `3px solid transparent`
    },
    '&::-webkit-scrollbar-thumb:horizontal': {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      backgroundClip: 'padding-box',
      borderRadius: '10px',
      border: `6px solid transparent`
    },
    '&::-webkit-scrollbar-button': {
      width: '0',
      height: '0',
      display: 'none'
    },
    '&::-webkit-scrollbar-corner': {
      display: 'none'
    }
  },
  layoutMStyle: {
    width: '100%',
    height: 'calc(50vh - 48px)',
    overflowY: 'auto',
    overflowX: 'auto',
    display: 'inline-grid',
    scrollbarColor: '#C4C4C4 transparent',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '10px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      backgroundClip: 'padding-box',
      borderRadius: '10px',
      border: `3px solid transparent`
    },
    '&::-webkit-scrollbar-thumb:horizontal': {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      backgroundClip: 'padding-box',
      borderRadius: '10px',
      border: `6px solid transparent`
    },
    '&::-webkit-scrollbar-button': {
      width: '0',
      height: '0',
      display: 'none'
    },
    '&::-webkit-scrollbar-corner': {
      display: 'none'
    }
  }
};
